import { createSelector } from "@reduxjs/toolkit";
import { scoreCRAFFT } from "services/scoring";

const checkInSlice = state => state.checkIn
export const selectLoading = createSelector(
  checkInSlice,
  checkIn => checkIn.loading
)
export const selectLastLoadingError = createSelector(
  checkInSlice,
  checkIn => checkIn.lastLoadingError
)
export const selectSaving = createSelector(
  checkInSlice,
  checkIn => checkIn.saving
)
export const selectSubmittingSurvey = createSelector(
  checkInSlice,
  checkIn => checkIn.submittingSurvey
)
export const selectSubmissionSuccessful = createSelector(
  checkInSlice,
  checkIn => checkIn.submissionSuccessful
)
export const selectLastSubmissionFailure = createSelector(
  checkInSlice,
  checkIn => checkIn.lastSubmissionFailure
)
export const selectAlreadySubmitted = createSelector(
  checkInSlice,
  checkIn => checkIn.alreadySubmitted
)
export const selectSurveyStarted = createSelector(
  checkInSlice,
  checkIn => checkIn.surveyStarted
)
export const selectCheckInStatus = createSelector(
  checkInSlice,
  checkIn => checkIn.status
)
export const selectStatusMeta = createSelector(
  checkInSlice,
  checkIn => checkIn.statusMeta
)
export const selectAnswers = createSelector(
  selectCheckInStatus,
  status => status.answers
)
export const selectPreviousStatus = createSelector(
  checkInSlice,
  checkIn => checkIn.previousStatus
)
export const getAnswer = (answers, { linkId, groupLinkId }) => {
  return answers?.[groupLinkId]?.[linkId]
}
export const selectAnswer = createSelector(
  [selectAnswers, (state, params) => params],
  getAnswer
)
const selectCQ = createSelector(
  selectAnswers,
  answers => answers.CQ
)
export const selectCRAFFTScore = createSelector(
  selectCQ,
  CQ => scoreCRAFFT(CQ)
)